import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import cn from "classnames";
import style from "../common.module.scss";
import CustomButton from "../../../custom/custom-button/CustomButton";
import moment from "moment";
import { numberToFinanceFormat } from "../../../../utils";
import { Order } from "../../../../services";
import { toast } from "react-toastify";
import { CURRENCIES } from "../../../../mock";
import { TenderDeadlineText } from "../../../shared/TenderDeadlineText/TenderDeadlineText";
import CommentIcon from "../../../shared/icons/CommentIcon";
import ArrowDownIcon from "../../../shared/icons/ArrowDownIcon";
import ArrowUpIcon from "../../../shared/icons/ArrowUpIcon";
import BoxIcon from "../../../shared/icons/BoxIcon";
import ScalesIcon from "../../../shared/icons/ScalesIcon";
import ConfirmModal from "../../../shared/ConfirmModal/ConfirmModal";

const ListSuggestedPrices = ({
  items = [],
  orderData = [],
  fetchOrderData,
  isExpeditor = "",
  ordersStatus,
  onUpdateData,
  isPublic = false,
  user = "",
  tenderDateEnd,
  cargoDetails,
  isMarketSuggested = false,
  isDriverSuggested = false,
}) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);
  const [activeCommentId, setActiveCommentId] = useState(null);
  const [confirmModal, setConfirmModal] = useState({ isOpen: false, id: null, isPublic: null });

  const toggleComment = (priceId) => {
    setActiveCommentId((prevId) => (prevId === priceId ? null : priceId));
  };

  const openConfirmModal = (id, isPublic) => {
    setConfirmModal({ isOpen: true, id, isPublic });
  };

  const handleConfirmAccept = () => {
    const { id, isPublic } = confirmModal;
    setLoading(true);

    const data = {
      moderator: user?.name,
    };

    Order.acceptOrderBidById(id, data)
      .then((res) => res.data)
      .then((response) => {
        toast.success(t("orderInfo.listSuggestedPrices.acceptSuccess"));
        setLoading(false);
        setConfirmModal({ isOpen: false, id: null, isPublic: null });
        onUpdateData();
        fetchOrderData();
      })
      .catch((error) => {
        console.error("Ошибка при принятии предложения:", error);
        toast.error(t("orderInfo.listSuggestedPrices.acceptError"));
        setLoading(false);
        setConfirmModal({ isOpen: false, id: null, isPublic: null });
      });
  };

  const handleCancelConfirm = () => {
    setConfirmModal({ isOpen: false, id: null, isPublic: null });
  };

  return (
    <div className={cn(style.cargo_wrapper, style.suggested_wrapper)}>
      {isMarketSuggested && orderData?.type === 0 && !isDriverSuggested && (
        <span className={style.suggested_infoLabel}>
          {t("orderInfo.listSuggestedPrices.marketplaceRequestsDescription")}
        </span>
      )}

      <div className={cn(style.orders_title, style.suggested_infoRow)}>
        <span className={style.suggested_infoLabel}>
          {isDriverSuggested
            ? t("orderInfo.listSuggestedPrices.driverRequestsDescription")
            : isMarketSuggested
              ? t("orderInfo.listSuggestedPrices.marketplaceRequestsList")
              : t("orderInfo.listSuggestedPrices.title")}
        </span>
        {tenderDateEnd && (
          <span className={cn(style.suggested_infoValue, style.suggested_deadline)}>
            <TenderDeadlineText date={tenderDateEnd} />
          </span>
        )}
      </div>

      <div className={cn(style.suggested_row, style.cargo_title, style.suggested_head)}>
        <div className={style.typography_small}>{t("orderInfo.listSuggestedPrices.columnName")}</div>
        <div className={style.typography_small}>{t("orderInfo.listSuggestedPrices.columnDate")}</div>
        <div className={style.typography_small}>
          {t("orderInfo.listSuggestedPrices.columnSuggestedAmount")}
        </div>
        <CustomButton
          isMini
          text={t("orderInfo.listSuggestedPrices.acceptButton")}
          isDisabled
          style={{ background: "transparent" }}
        />
      </div>

      {items.map((item) => (
        <React.Fragment key={item.id}>
          <div className={style.suggested_row}>
            <div className={cn(style.typography_titleSmall, style.suggested_lineClamp)}>
              {item.expeditorName || item?.userName}
            </div>
            <div className={style.typography_small}>
              {moment(item?.createdAt).format("DD.MM.YYYY")} {t("orderInfo.listDocsOrder.dateTimeConnector")}{" "}
              {moment(item?.createdAt).format("HH:mm")}
            </div>
            <div className={style.typography_titleSmall} style={{ display: "flex" }}>
              {numberToFinanceFormat(item.price)} {CURRENCIES[item?.currency || "KZT"]?.symbol || ""}
              {(item?.comments || item?.volume || item?.weight) && (
                <div className={style.comment_toggle} onClick={() => toggleComment(item.id)}>
                  <CommentIcon fill="#2196F3" />
                  {activeCommentId === item.id ? (
                    <ArrowUpIcon stroke="#2196F3" />
                  ) : (
                    <ArrowDownIcon stroke="#2196F3" />
                  )}
                </div>
              )}
            </div>

            {ordersStatus === "awaitingoffer" || ordersStatus === "published" ? (
              <CustomButton
                isMini
                text={t("orderInfo.listSuggestedPrices.acceptButton")}
                onClick={() => openConfirmModal(item.id, isPublic)}
                isLoading={isLoading}
              />
            ) : item?.isAccepted ? (
              <span className={style.acceptedText}>{t("orderInfo.listSuggestedPrices.acceptedStatus")}</span>
            ) : null}
          </div>

          {activeCommentId === item.id && (item?.comments || item?.volume || item?.weight) && (
            <div className={style.comment_row}>
              <div className={style.comment_content}>
                {item?.comments && (
                  <div>
                    <span className={style.comment_label}>
                      {t("orderInfoExpeditor.suggestPrice.transitDaysLabel")}:{" "}
                      <span className={style.comment_text}> {item.comments}</span>
                    </span>
                  </div>
                )}

                <div className={style.comment_volume}>
                  {item?.weight && (
                    <span>
                      <ScalesIcon width="24px" height="24px" /> {t("orderInfo.ordersInfoCargo.massLabel")}{" "}
                      {item.weight}{" "}
                      {cargoDetails.unitMeasurement === "Kg"
                        ? t("orderInfo.ordersInfoCargo.kgUnit")
                        : t("orderInfo.ordersInfoCargo.tonsUnit")}
                    </span>
                  )}
                  {item?.volume && (
                    <span>
                      <BoxIcon width="24px" height="24px" /> {t("orderInfo.ordersInfoCargo.dimensionsLabel")}{" "}
                      {item.volume}{" "}
                      <span>
                        {t("ordersCreateDesktop.detailsSection.volumeUnit")}
                        <sup>3</sup>
                      </span>
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      ))}
      <ConfirmModal
        isOpen={confirmModal.isOpen}
        title={t("orderInfo.listSuggestedPrices.confirmMessage")}
        onConfirm={handleConfirmAccept}
        onCancel={handleCancelConfirm}
        isLoading={isLoading}
      />
    </div>
  );
};

export default ListSuggestedPrices;
